/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterSpacing = createReactComponent("outline", "letter-spacing", "IconLetterSpacing", [["path", { "d": "M5 12v-5.5a2.5 2.5 0 0 1 5 0v5.5m0 -4h-5", "key": "svg-0" }], ["path", { "d": "M13 4l3 8l3 -8", "key": "svg-1" }], ["path", { "d": "M5 18h14", "key": "svg-2" }], ["path", { "d": "M17 20l2 -2l-2 -2", "key": "svg-3" }], ["path", { "d": "M7 16l-2 2l2 2", "key": "svg-4" }]]);

export { IconLetterSpacing as default };
//# sourceMappingURL=IconLetterSpacing.mjs.map
